import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vModelText as _vModelText, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-20d51cd2"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "font-semibold text-xl text-gray-800 leading-tight" }, " 問題情報管理 ", -1));
const _hoisted_2 = { class: "max-w-7xl mx-auto py-10 sm:px-6 lg:px-8" };
const _hoisted_3 = { class: "shadow-lg bg-white rounded-lg rounded-b-none p-6" };
const _hoisted_4 = { class: "grid grid-cols-12" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pr-4 text-right",
    for: "question_id"
}, " 問題ID ", -1));
const _hoisted_6 = {
    id: "question_id",
    class: "col-span-8"
};
const _hoisted_7 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "field_name"
}, " 分野 ", -1));
const _hoisted_9 = { class: "col-span-8" };
const _hoisted_10 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "correct_answer"
}, " 表示写真（問題用） ", -1));
const _hoisted_12 = { class: "col-span-8" };
const _hoisted_13 = {
    key: 0,
    class: "relative w-full md:w-80 mb-3 object-cover"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = ["onClick"];
const _hoisted_16 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "question"
}, " 問題文 ", -1));
const _hoisted_18 = { class: "col-span-8" };
const _hoisted_19 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "correct_answer"
}, " 正答 ", -1));
const _hoisted_21 = { class: "col-span-8" };
const _hoisted_22 = ["for"];
const _hoisted_23 = { class: "col-span-8" };
const _hoisted_24 = ["id", "onUpdate:modelValue"];
const _hoisted_25 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "correct_answer"
}, " 表示写真（解説用） ", -1));
const _hoisted_27 = { class: "col-span-8" };
const _hoisted_28 = {
    key: 0,
    class: "relative w-full md:w-80 mb-3 object-cover"
};
const _hoisted_29 = ["src"];
const _hoisted_30 = ["onClick"];
const _hoisted_31 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "commentary"
}, " 解説 ", -1));
const _hoisted_33 = { class: "col-span-8" };
const _hoisted_34 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "difficulty"
}, " 難易度 ", -1));
const _hoisted_36 = { class: "col-span-8" };
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "0" }, "未設定", -1));
const _hoisted_38 = ["value"];
const _hoisted_39 = { class: "grid grid-cols-12 mt-4" };
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "col-span-2 pt-2 pr-4 text-right",
    for: "correct_answer"
}, " タグ ", -1));
const _hoisted_41 = { class: "col-span-8" };
const _hoisted_42 = {
    key: 0,
    class: "grid grid-cols-12 mt-4"
};
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "inline-block col-span-2 pt-5 pr-4 text-right",
    for: "correct_answer"
}, " 追加済み模試リスト ", -1));
const _hoisted_44 = { class: "col-span-8" };
const _hoisted_45 = { key: 0 };
const _hoisted_46 = { class: "md:w-1/3 rounded-full py-3 px-4 bg-indigo-200 text-center" };
const _hoisted_47 = {
    key: 0,
    class: "inline-block ml-4"
};
const _hoisted_48 = {
    key: 1,
    class: "pt-5 text-red-500"
};
const _hoisted_49 = { class: "flex items-center mb-10 justify-end px-4 py-3 bg-gray-50 text-right shadow rounded-b-lg" };
const _hoisted_50 = ["disabled"];
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "mr-3 flex-1" }, null, -1));
const _hoisted_52 = ["disabled", "onClick"];
const _hoisted_53 = {
    key: 0,
    class: "flex mt-10 items-center justify-end px-4 py-3 text-right shadow rounded-lg bg-red-100"
};
const _hoisted_54 = ["disabled", "onClick"];
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "flex" }, [
    /*#__PURE__*/ _createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "h-6 w-6 text-red-500",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        "stroke-width": "2"
    }, [
        /*#__PURE__*/ _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
        })
    ]),
    /*#__PURE__*/ _createElementVNode("div", { class: "ml-2 text-red-500" }, " 問題の表示写真を削除してもよろしいですか？ ")
], -1));
const _hoisted_56 = { class: "w-full px-4" };
const _hoisted_57 = ["src"];
const _hoisted_58 = /*#__PURE__*/ _createTextVNode(" キャンセル ");
import { ref, computed, reactive, onMounted, } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import { SmartTagz } from 'smart-tagz';
import AppLayout from '@/Layouts/AppLayout.vue';
import WhiteButton from '../../Common/Button.vue';
import InputError from '@/Jetstream/InputError.vue';
import 'smart-tagz/dist/smart-tagz.css';
import DialogModal from '../../Common/DialogModal.vue';
// @ts-ignore
import route from '@/types/Route';
export default /*#__PURE__*/ _defineComponent({
    props: {
        question: {
            type: Object,
            required: false,
            default: () => ({ id: null }),
        },
        subject: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        fields: {
            type: Array,
            required: false,
            default: () => [],
        },
        imagePath: {
            type: String,
            required: false,
            default: null,
        },
        allTags: {
            type: Array,
            required: false,
            default: () => [],
        },
        flash: {
            type: Object,
            default: () => { },
        },
        page: {
            type: String,
            default: '',
        },
        limit: {
            type: String,
            default: '',
        },
        difficulties: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
    setup(__props) {
        const props = __props;
        const flashObject = computed(() => ({
            flash: props.flash,
        }));
        const show = ref(false);
        const form = reactive(Inertia.form({
            id: null,
            _method: 'POST',
            subject_id: null,
            field_name: null,
            question: null,
            correct_answer: null,
            dummy_answer1: null,
            dummy_answer2: null,
            dummy_answer3: null,
            dummy_answer4: null,
            commentary: null,
            difficulty: null,
            tags: props.question.id
                ? props.question.tags.map((tag) => tag.name)
                : [],
            imageQuestion: null,
            imageCommentary: null,
            limit: null,
            page: null,
        }));
        const examinationTypeText = (type) => {
            switch (type) {
                case 1:
                    return '必須';
                case 2:
                    return '一般';
                case 3:
                    return '実地';
                default:
                    return '';
            }
        };
        onMounted(() => {
            if (props.question.id) {
                form._method = 'PUT'; // eslint-disable-line no-underscore-dangle
                form.id = props.question.id;
                form.field_name = props.question.field_name;
                form.question = props.question.question;
                form.correct_answer = props.question.correct_answer;
                form.dummy_answer1 = props.question.dummy_answer1;
                form.dummy_answer2 = props.question.dummy_answer2;
                form.dummy_answer3 = props.question.dummy_answer3;
                form.dummy_answer4 = props.question.dummy_answer4;
                form.commentary = props.question.commentary;
                form.difficulty = props.question.difficulty ?? 0;
                form.tags = props.question.tags.map((tag) => tag.name);
                form.limit = props.limit;
                form.page = props.page;
            }
            form.subject_id = props.subject.id;
        });
        const refImageQuestion = ref();
        const refImageCommentary = ref();
        const onSubmitted = async () => {
            if (refImageQuestion.value) {
                form.imageQuestion = refImageQuestion.value?.files?.[0];
            }
            if (refImageCommentary.value) {
                form.imageCommentary = refImageCommentary.value?.files?.[0];
            }
            if (props.question.id) {
                const params = {
                    subject: props.subject,
                    question: props.question,
                };
                await form.post(route('questions.update', params));
            }
            else {
                const params = {
                    subject: props.subject,
                };
                await form.post(route('questions.store', params));
            }
        };
        const imageQuestionPreview = ref(null);
        const imageCommentaryPreview = ref(null);
        const openFileView = (event) => {
            const { target } = event;
            if (target.name === 'image_url_question') {
                refImageQuestion?.value?.click();
            }
            if (target.name === 'image_url_commentary') {
                refImageCommentary?.value?.click();
            }
        };
        const onFileChanged = (name) => {
            const reader = new FileReader();
            if (name === 'image_url_question') {
                reader.onload = (e) => {
                    imageQuestionPreview.value = e.target.result;
                };
                reader.readAsDataURL(refImageQuestion?.value?.files?.[0]);
            }
            if (name === 'image_url_commentary') {
                reader.onload = (e) => {
                    imageCommentaryPreview.value = e.target.result;
                };
                reader.readAsDataURL(refImageCommentary?.value?.files?.[0]);
            }
        };
        const onReturnClicked = () => {
            const params = {
                subject: props.subject,
            };
            history.back();
        };
        const onDeletionButtonClicked = async () => {
            const params = {
                subject: props.subject,
                question: props.question,
            };
            await form.delete(route('questions.destroy', params));
        };
        const onTagChanged = (result) => {
            form.tags = result;
        };
        const hasImageQuestion = computed(() => imageQuestionPreview.value || props.question.image_url_question);
        const hasImageCommentary = computed(() => imageCommentaryPreview.value || props.question.image_url_commentary);
        const targetDeleteImageUrl = ref('');
        const targetDeleteImageEvent = ref();
        const targetPreviewImageName = ref('');
        const confirmImagePreview = computed(() => {
            if (targetPreviewImageName.value === 'image_path_question') {
                return props.question.image_url_question;
            }
            if (targetPreviewImageName.value === 'image_path_commentary') {
                return props.question.image_url_commentary;
            }
            return '';
        });
        const onConfirmImageButtonClicked = (url, name, event) => {
            targetPreviewImageName.value = name;
            targetDeleteImageUrl.value = url;
            targetDeleteImageEvent.value = event;
            show.value = true;
        };
        const onDeleteImageButtonClicked = () => {
            const image = targetDeleteImageUrl.value.replace('/storage/', '');
            Inertia.delete(route('delete.question.image', {
                image,
                subjectId: props.subject.id,
                questionId: props.question.id,
                targetImagePath: targetPreviewImageName.value,
            }));
            show.value = false;
            targetPreviewImageName.value = '';
            targetDeleteImageUrl.value = '';
            targetDeleteImageEvent.value = '';
            form.image = '';
        };
        const onDeleteImageCanceled = () => {
            show.value = !show.value;
            targetPreviewImageName.value = '';
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(AppLayout, _mergeProps(_unref(flashObject), { title: "QuestionShow" }), {
                header: _withCtx(() => [
                    _hoisted_1
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _hoisted_5,
                                _createElementVNode("div", _hoisted_6, _toDisplayString(props.question.id), 1)
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                                _hoisted_8,
                                _createElementVNode("div", _hoisted_9, [
                                    _withDirectives(_createElementVNode("select", {
                                        id: "field_name",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(form).field_name) = $event)),
                                        class: _normalizeClass({ 'bg-red-100': !!_unref(form).errors.field_name })
                                    }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.fields, (field) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: field.id
                                            }, _toDisplayString(field.title), 1));
                                        }), 128))
                                    ], 2), [
                                        [_vModelSelect, _unref(form).field_name]
                                    ]),
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.field_name,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _hoisted_11,
                                _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("input", {
                                        ref: (_value, _refs) => {
                                            _refs['refImageQuestion'] = _value;
                                            refImageQuestion.value = _value;
                                        },
                                        type: "file",
                                        accept: ".jpeg, .jpg, .png",
                                        class: "hidden",
                                        onChange: _cache[1] || (_cache[1] = ($event) => (onFileChanged('image_url_question')))
                                    }, null, 544),
                                    (_unref(hasImageQuestion))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                            (__props.question.image_url_question)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: "delete-button",
                                                    onClick: _cache[2] || (_cache[2] = ($event) => (onConfirmImageButtonClicked(__props.question.image_url_question, 'image_path_question', $event)))
                                                }, " × "))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("img", {
                                                src: imageQuestionPreview.value ?? __props.question.image_url_question
                                            }, null, 8, _hoisted_14)
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("button", {
                                        class: "px-4 py-2 rounded bg-blue-600 text-xs text-blue-50 max-w-max shadow-sm hover:shadow-lg",
                                        name: "image_url_question",
                                        onClick: _withModifiers(openFileView, ["prevent"])
                                    }, " 画像追加 ", 8, _hoisted_15),
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.image,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                                _hoisted_17,
                                _createElementVNode("div", _hoisted_18, [
                                    _withDirectives(_createElementVNode("textarea", {
                                        id: "question",
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(form).question) = $event)),
                                        class: _normalizeClass(["w-full rounded border-gray-400", { 'bg-red-100': !!_unref(form).errors.question }]),
                                        rows: "10"
                                    }, "\n            ", 2), [
                                        [_vModelText, _unref(form).question]
                                    ]),
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.question,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                                _hoisted_20,
                                _createElementVNode("div", _hoisted_21, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "correct_answer",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(form).correct_answer) = $event)),
                                        type: "text",
                                        class: _normalizeClass(["w-full rounded border-gray-400", { 'bg-red-100': !!_unref(form).errors.correct_answer }])
                                    }, null, 2), [
                                        [_vModelText, _unref(form).correct_answer]
                                    ]),
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.correct_answer,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ]),
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4], (index) => {
                                return _createElementVNode("div", {
                                    key: `answer-${index}`,
                                    class: "grid grid-cols-12 mt-4"
                                }, [
                                    _createElementVNode("label", {
                                        class: "col-span-2 pt-2 pr-4 text-right",
                                        for: `dummy_answer${index}`
                                    }, " 誤答" + _toDisplayString(index), 9, _hoisted_22),
                                    _createElementVNode("div", _hoisted_23, [
                                        _withDirectives(_createElementVNode("input", {
                                            id: `dummy_answer${index}`,
                                            "onUpdate:modelValue": ($event) => ((_unref(form)[`dummy_answer${index}`]) = $event),
                                            type: "text",
                                            class: _normalizeClass(["w-full rounded border-gray-400", { 'bg-red-100': !!_unref(form).errors[`dummy_answer${index}`] }])
                                        }, null, 10, _hoisted_24), [
                                            [_vModelText, _unref(form)[`dummy_answer${index}`]]
                                        ]),
                                        _createVNode(InputError, {
                                            message: _unref(form).errors[`dummy_answer${index}`],
                                            class: "mt-2"
                                        }, null, 8, ["message"])
                                    ])
                                ]);
                            }), 64)),
                            _createElementVNode("div", _hoisted_25, [
                                _hoisted_26,
                                _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("input", {
                                        ref: (_value, _refs) => {
                                            _refs['refImageCommentary'] = _value;
                                            refImageCommentary.value = _value;
                                        },
                                        type: "file",
                                        accept: ".jpeg, .jpg, .png",
                                        class: "hidden",
                                        onChange: _cache[5] || (_cache[5] = ($event) => (onFileChanged('image_url_commentary')))
                                    }, null, 544),
                                    (_unref(hasImageCommentary))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                            (__props.question.image_url_commentary)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: "delete-button",
                                                    onClick: _cache[6] || (_cache[6] = ($event) => (onConfirmImageButtonClicked(__props.question.image_url_commentary, 'image_path_commentary', $event)))
                                                }, " × "))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("img", {
                                                src: imageCommentaryPreview.value ?? __props.question.image_url_commentary
                                            }, null, 8, _hoisted_29)
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("button", {
                                        class: "px-4 py-2 rounded bg-blue-600 text-xs text-blue-50 max-w-max shadow-sm hover:shadow-lg",
                                        name: "image_url_commentary",
                                        onClick: _withModifiers(openFileView, ["prevent"])
                                    }, " 画像追加 ", 8, _hoisted_30),
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.image,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                                _hoisted_32,
                                _createElementVNode("div", _hoisted_33, [
                                    _withDirectives(_createElementVNode("textarea", {
                                        id: "commentary",
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(form).commentary) = $event)),
                                        class: _normalizeClass(["w-full rounded border-gray-400", { 'bg-red-100': !!_unref(form).errors.commentary }]),
                                        rows: "10"
                                    }, "\n            ", 2), [
                                        [_vModelText, _unref(form).commentary]
                                    ]),
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.commentary,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                                _hoisted_35,
                                _createElementVNode("div", _hoisted_36, [
                                    _withDirectives(_createElementVNode("select", {
                                        id: "difficulty",
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(form).difficulty) = $event)),
                                        class: _normalizeClass({ 'bg-red-100': !!_unref(form).errors.difficulty })
                                    }, [
                                        _hoisted_37,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.difficulties, (difficulty, i) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: difficulty.id,
                                                value: i + 1
                                            }, _toDisplayString(difficulty.name), 9, _hoisted_38));
                                        }), 128))
                                    ], 2), [
                                        [_vModelSelect, _unref(form).difficulty]
                                    ]),
                                    _createVNode(InputError, {
                                        message: _unref(form).errors.difficulty,
                                        class: "mt-2"
                                    }, null, 8, ["message"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_39, [
                                _hoisted_40,
                                _createElementVNode("div", _hoisted_41, [
                                    _createVNode(_unref(SmartTagz), {
                                        autosuggest: "",
                                        editable: "",
                                        "quick-delete": false,
                                        "input-placeholder": "入力してEnterキーで追加",
                                        sources: __props.allTags,
                                        "allow-paste": { delimiter: ',' },
                                        "allow-duplicates": false,
                                        "max-tags": 20,
                                        "default-tags": _unref(form).tags,
                                        "on-changed": onTagChanged
                                    }, null, 8, ["sources", "default-tags"])
                                ])
                            ]),
                            (__props.question.id)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                    _hoisted_43,
                                    _createElementVNode("div", _hoisted_44, [
                                        (Array.isArray(__props.question.examinations) &&
                                            __props.question.examinations.length)
                                            ? (_openBlock(), _createElementBlock("ul", _hoisted_45, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.question.examinations, (item, index) => {
                                                    return (_openBlock(), _createElementBlock("li", {
                                                        key: index,
                                                        class: "pt-2"
                                                    }, [
                                                        _createElementVNode("div", _hoisted_46, [
                                                            _createElementVNode("span", null, _toDisplayString(item.title), 1),
                                                            (item.pivot.examination_type)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(examinationTypeText(item.pivot.examination_type)) + "問題 ", 1))
                                                                : _createCommentVNode("", true)
                                                        ])
                                                    ]));
                                                }), 128))
                                            ]))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_48, " まだ模試に問題を追加されていません。 "))
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                            (!_unref(form).wasSuccessful)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: _normalizeClass([{ 'opacity-25': _unref(form).processing }, "px-8 py-2 rounded border border-blue-600 text-blue-600 max-w-max shadow-sm hover:shadow-lg"]),
                                    disabled: _unref(form).processing,
                                    onClick: onReturnClicked
                                }, " 戻る ", 10, _hoisted_50))
                                : _createCommentVNode("", true),
                            _hoisted_51,
                            (!_unref(form).wasSuccessful)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: _normalizeClass([{ 'opacity-25': _unref(form).processing }, "px-8 py-2 rounded bg-blue-600 text-blue-50 max-w-max shadow-sm hover:shadow-lg"]),
                                    disabled: _unref(form).processing,
                                    onClick: _withModifiers(onSubmitted, ["prevent"])
                                }, " 保存する ", 10, _hoisted_52))
                                : _createCommentVNode("", true)
                        ]),
                        (__props.question.id)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                (!_unref(form).wasSuccessful)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: _normalizeClass([{ 'opacity-25': _unref(form).processing }, "px-8 py-2 rounded bg-red-700 text-blue-50 max-w-max shadow-sm hover:shadow-lg"]),
                                        disabled: _unref(form).processing,
                                        onClick: _withModifiers(onDeletionButtonClicked, ["prevent"])
                                    }, " 削除する ", 10, _hoisted_54))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createVNode(DialogModal, {
                        show: show.value,
                        "max-width": "lg",
                        onClose: onDeleteImageCanceled
                    }, {
                        title: _withCtx(() => [
                            _hoisted_55
                        ]),
                        content: _withCtx(() => [
                            _createElementVNode("div", _hoisted_56, [
                                _createElementVNode("img", {
                                    src: _unref(confirmImagePreview),
                                    class: "mx-auto h-64 w-96 object-cover"
                                }, null, 8, _hoisted_57)
                            ])
                        ]),
                        footer: _withCtx(() => [
                            _createVNode(WhiteButton, {
                                class: "mr-4 bg-white text-black",
                                onClick: onDeleteImageCanceled
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_58
                                ]),
                                _: 1
                            }),
                            _createElementVNode("button", {
                                class: "px-8 py-2 bg-red-600 text-red-50 rounded max-w-max shadow-sm hover:shadow-lg",
                                onClick: onDeleteImageButtonClicked
                            }, " 削除 ")
                        ]),
                        _: 1
                    }, 8, ["show"])
                ]),
                _: 1
            }, 16));
        };
    }
});
